import { ActionFunctionArgs } from 'react-router-dom';

import { QueryClient } from '@tanstack/react-query';

import { isDefined } from '@hsp/utilities';

import { authenticationService } from 'services';
import { IForgotPassword } from 'types/user';
import { s } from 'utilities/strings';

export const forgotAction = (_: QueryClient) => {
  return async ({ request }: ActionFunctionArgs) => {
    const formData = await request.formData();
    const forgotRequest: Record<string, string> = {};

    formData.forEach((value, key) => (forgotRequest[key] = value as string));

    try {
      let fn: null | ((data: IForgotPassword) => Promise<string> | undefined) = null;

      if (process.env.REACT_APP_API_AUTH_FAKE === 'jwt') {
        fn = authenticationService.postJwtForgetPwd;
      } else {
        fn = authenticationService.postFakeForgetPwd;
      }

      if (isDefined(fn)) {
        const response = await fn.call(authenticationService, forgotRequest as unknown as IForgotPassword);

        if (!isDefined(response)) {
          throw new Error(s('Api.UnknownError'));
        }

        return 'Reset link are sended to your mailbox, check there first';
      }

      throw new Error(s('Api.UnknownError'));
    } catch (e) {
      return { error: e };
    }
  };
};
